import { useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import { refundPolicyData } from '../Common/RefundPolicyData';
import FooterComponent from '../Common/FooterComponent';
import FeedbackPopup from '../Common/FeedbackPopup';
import { useState } from 'react';

function RefundPolicy(){

    const [showFeedbackPopup, setShowFeedbackPopup] = useState(false);

    const isShowConsole = process.env.NODE_ENV === 'development';

    const location = useLocation();
    isShowConsole && console.log("Current Path:", location.pathname); 
    
    const refundPolicyEle = refundPolicyData.map((ele, idx) => {
        return(
            <div className='ppEle' key={idx}>
                <div className='ppHeader'>{ele.header}</div>
                <div className='ppContent'>{ele.content}</div>
            </div>
        )
    });

    return(
        <div className='parentDiv'>
            <div className='mainDiv refundPolicy'>
                <div className='header'>
                    <Navbar />
                </div>
                <div className='contentDiv'>
                    <div className='containerDiv'>
                        <div className='title'>Refund Policy</div>
                        <div className='contentBox'>
                            <div className='content'>
                                {refundPolicyEle}
                            </div>
                        </div>
                    </div>
                </div>
                {showFeedbackPopup && <FeedbackPopup closeFeedbackPopup={() => setShowFeedbackPopup(false)}/>}
            </div>
            <FooterComponent setShowFeedbackPopup={setShowFeedbackPopup}/>
        </div>
    )
}

export default RefundPolicy;